module.exports = __webpack_public_path__ + "static/media/Google.489031ad.png";